<div *ngIf="global.globalAgencyId==null || global.globalAgencyId==undefined ||global.globalAgencyId=='00000000-0000-0000-0000-000000000000' || global.globalAgencyId=='' ">
    <div class="row mt-4 ">
        <div class="col ">
            <div widget class="card border-0 box-shadow">
                <div class="card-body  widget-body pt-2">
                    <div class="text-center text-danger">
                        <label class="font-red animate-charcter"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select
                            agency to view
                            details</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000'&& !this.inputfromCalendar">
    <div class="col-12">
        <h4 class="mb-2 font-header-1">Events</h4>
    </div>
    <div class="col-12 mt-3 p-0">
        <div widget class="card border-0 box-shadow">
            <div class="card-header transparent">
                <div class="d-flex">
                    <div class="col-3">
                        <div class="col-lg-12">
                            <label class="fs-size">StartDate<sup class="super-script">*</sup></label>
                        </div>
                        <div class="col-lg-8 mt-1">
                            <my-date-picker class="w-100" placeholder="mm/dd/yyyy" 
                                [options]="myDatePickerOptions"
                                (inputFieldChanged)="newdates($event,'inputchange','StartDate')"
                                [selDate]="FilterStartDate" (dateChanged)="newdates($event,'datechanged','StartDate')">
                            </my-date-picker>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="col-lg-12">
                            <label class="fs-size">EndDate<sup class="super-script">*</sup></label>
                        </div>
                        <div class="col-lg-8 mt-1">
                            <my-date-picker class="w-100" placeholder="mm/dd/yyyy" 
                                [options]="myDatePickerOptions"
                                (inputFieldChanged)="newdates($event,'inputchange','EndDate')" [selDate]="FilterEndDate"
                                (dateChanged)="newdates($event,'datechanged','EndDate')">
                            </my-date-picker>
                        </div>
                    </div>
                    <div class="col-3" >
                        <div class="col-lg-12">
                            <label class="fs-size">Client</label>
                        </div>
                        <div class="col-lg-10 mt-1">
                            <ng-select [(ngModel)]="EBO.clientId" [searchable]="true" [clearable]="true" [disabled]="EBO.isedit"
                                [items]="ClientList" bindLabel="Value" bindValue="Key">
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="col-lg-12">
                            <label class="fs-size">Employee</label>
                        </div>
                        <div class="col-lg-10 mt-1">
                            <ng-select [(ngModel)]="EBO.consultantId" [searchable]="true" [clearable]="true"
                                [items]="UserDropDownList" bindLabel="Value" bindValue="Key">
                            </ng-select>
                        </div>
                    </div>
                </div>

            </div>
            <div class="card-body transparent">
                <div class="row mb-2 d-flex justify-content-center align-items-center">
                    <div class="col-lg-2 col-md-2 col-sm-6">
                        <button type="button" class="btn btn-sm" data-bs-toggle="modal"
                            data-bs-target="#CreateEventsModal" (click)="addclientid()" >
                            Add Events
                        </button>
                    </div>
                    <div class="col-lg-4 col-md-5 col-sm-6 d-inline-flex justify-content-center mt-2 pt-1">
                    </div>
                    <div class="col-lg-3 col-md-5 col-sm-6">
                    </div>
                    <div class="col-lg-3 col-md-12 col-sm-6 d-flex justify-content-lg-end">
                        <button class="btn btn-sm me-4" type="button" [disabled]="FilterStartDate==null|| FilterStartDate==undefined||
                        FilterStartDate=='' || FilterEndDate==null || FilterEndDate==undefined || FilterEndDate==''"
                            (click)="getEventsListFilter()">Apply</button>
                        <button class="btn btn-sm " type="button" (click)="Refresh()" *ngIf="!EBO.isedit"><i
                                class="fa fa-repeat">&nbsp;</i>Refresh</button>
                    </div>
                </div>
                <div class="row mt-2 pt-1">
                    <div class="col-12">
                        <ejs-grid #gridEvents id="gridEvents" [dataSource]='GridDataEvent | async'
                            [allowResizing]='true' [allowSorting]='true' [showColumnChooser]='true' [allowPaging]='true'
                            [allowFiltering]='true' (dataStateChange)='dataStateChange($event)'
                            [pageSettings]='initialPage' [filterSettings]='filterOptions' 
                            (actionComplete)="onActionComplete($event)" [selectionSettings]='selectionOptions'  >
                            
                            <e-columns>
                                <!-- (rowSelected)="onRowSelected($event)"  -->
                                <e-column field='' headerText="Actions" width="100" [showInColumnChooser]='false'
                                    textAlign='center'>
                                    <ng-template #template let-data>
                                        <button class="btn btn-edit-table" (click)="EditEvents($event,data)"> <i
                                                class="fa fa-edit"></i></button>
                                        <button class=" btn btn-delete-table ms-3" (click)="getDeleteId($event,data)">
                                            <i class="fa fa-trash "></i></button>

                                    </ng-template>
                                </e-column>
                                <!-- Client Name -->
                                <e-column field="clientName" headerText='Client Name' textAlign='left'
                                    [allowEditing]='false' type='string'   width="150">
                                    <ng-template #template let-data>
                                        <a (click)="clickCLientName(data)">
                                            {{ data.clientName }}
                                        </a>
                                    </ng-template>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value">
                                        </ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- Consultant Name -->
                                <e-column field="consultantName" headerText="Employee Name"  width="150" textAlign='left'
                                    [allowEditing]='false' type='string'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value">
                                        </ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                 <e-column field="clientPhone" headerText="Client Phone"  width="150" textAlign='left'
                                    [allowEditing]='false' type='string'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value">
                                        </ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- Start Time -->
                                <e-column field="startTime" headerText="Start Time"  width="170" textAlign='left' type="datetime"
                                    [format]='datetimeformat' [allowFiltering]='false' >
                                </e-column>
                                <!-- End Time -->
                                <e-column field='endTime' headerText='End Time'  width="170" textAlign='left' type="datetime"
                                    [format]='datetimeformat' [allowFiltering]='false' >
                                </e-column>

                                <!--Event Title -->
                                <e-column field="eventTitle" headerText="Event Title"  width="150" textAlign='left'
                                    [allowEditing]='false' type='string'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value">
                                        </ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- "Event Description -->
                                <e-column field="eventDescription" headerText="Event Description"  width="150" textAlign='left'
                                    [allowEditing]='false' type='string'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value">
                                        </ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>   
                                <e-column field="statusName" headerText="Status" textAlign='left'  width="150" [allowEditing]='false'
                                    type='string'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value">
                                        </ejs-maskedtextbox>
                                    </ng-template>
                                </e-column> 
                                  <e-column field="confirmationChannel" headerText="Confirmation Channel" textAlign='left'  width="150" 
                                    type='string'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value">
                                        </ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>                               
                                <e-column field="confirmationStatus" headerText="Confirmation Status"  width="150" textAlign='left'
                                     type='string'   >
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value">
                                        </ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column field="attemptCount" headerText="Attempt Count"  width="150" textAlign='left'
                                 type='number' >
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value">
                                    </ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <e-column field="initiatedAt" headerText="Initiated At"  width="150" textAlign='left'
                            [allowEditing]='false'  type='datetime'   [format]='datetimeformat' >                    
                            </e-column>
                            <e-column field="respondedAt" headerText="Responded At"  width="150" textAlign='left'
                            [allowEditing]='false'  type='datetime'   [format]='datetimeformat' >                    
                            </e-column>
                            

                                                                 <!-- Plan model-->
                                                                 <e-column field="cfssModel" headerText="Plan Model" textAlign='left'
                                                                 [allowEditing]='false' type='string' width="115">
                                                                 <ng-template #filterTemplate let-data>
                                                                     <ejs-maskedtextbox placeholder="Enter the value">
                                                                     </ejs-maskedtextbox>
                                                                 </ng-template>
                                                             </e-column>
                                                               <!-- language-->
                                                               <e-column field="languages" headerText="Languages" textAlign='left'
                                                               [allowEditing]='false' type='string'  width="150" [allowFiltering]='false' [allowSorting]='false'>
                                                               <ng-template #filterTemplate let-data>
                                                                   <ejs-maskedtextbox placeholder="Enter the value">
                                                                   </ejs-maskedtextbox>
                                                               </ng-template>
                                                           </e-column>
                            <e-column field="createdTime" headerText="Created Time"  width="150" textAlign='left'
                            [allowEditing]='false' type='datetime' [format]='datetimeformat'> 
                            </e-column>
                            <e-column field="modifiedTime" headerText="Modified Time"  width="150" textAlign='left'
                            [allowEditing]='false' type='datetime'  [format]='datetimeformat'>                            
                            </e-column>                                
                                
                                <e-column width="50" [showInColumnChooser]='false'>
                                    <ng-template #headerTemplate let-data>
                                        <div class="d-none d-lg-block">
                                            <span id='show' (click)='show()'><i class="fa fa-cog fa-lg"
                                                    aria-hidden="true">
                                                </i></span>
                                        </div>
                                    </ng-template>
                                </e-column>
                            </e-columns>
                        </ejs-grid>
                    </div>
                    <div class="col-lg-12">
                        <div *ngIf="EventsDataList.length == 0" class="text-center" style="color:red">
                            <p>No data available</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- For Create Events -->
<span id="openEventsModal" data-bs-toggle="modal" data-bs-target="#CreateEventsModal"></span>
<div class="modal fade" id="CreateEventsModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog mw-100" role="document">
        <div class="modal-content">
            <div class="modal-header border-0">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                    <span
                        *ngIf="saveBo.id==null|| saveBo.id==undefined|| saveBo.id=='00000000-0000-0000-0000-000000000000'">
                        Create Event</span>
                    <span
                        *ngIf="saveBo.id!=null && saveBo.id!=undefined && saveBo.id!='00000000-0000-0000-0000-000000000000'">
                        Update Event</span>
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="clearEvents()">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row mb-2">
                    <div class="col pl-0">
                        <div widget class="card border-0 box-shadow" style="background-color: aliceblue;">
                            <div class="card-body  widget-body pt-2">
                                <div class="row pl-4">
                                    <div class="col-lg-12">
                                        <!-- 1 -->
                                        <div class="row ">
                                            <div class="col-lg-12 br-line">
                                                <div class="row mt-1">
                                                    <!--Client Name -->
                                                    <div class="col-lg-6 col-md-6 d-inline-flex ">
                                                        <label class="mr-1 label-bold w-75"> Client Name <sup class="super-script">*</sup></label>
                                                        <ng-select [(ngModel)]="saveBo.clientId" [searchable]="true"
                                                            class="w-100" [clearable]="true" [items]="ClientList" [disabled]="EBO.isedit || isEditClient"
                                                            bindLabel="Value" bindValue="Key"  (ngModelChange)="Getclientmodelandlanguage(true)">
                                                        </ng-select>
                                                    </div>
                                                    <!-- Consultant name -->
                                                    <div class="col-lg-6 col-md-6 d-inline-flex ">
                                                        <label class="mr-1 label-bold  w-75">Employee Name <sup class="super-script">*</sup></label>
                                                        <ng-select [(ngModel)]="saveBo.consultantId" [searchable]="true"
                                                            class="w-100" [clearable]="true" [items]="UserDropDownList"
                                                            bindLabel="Value" bindValue="Key">
                                                        </ng-select>
                                                    </div>
                                                </div>

                                                <div class="row mt-1">
                                                    <!-- Title -->
                                                    <div class="col-lg-6 col-md-6 d-inline-flex ">
                                                        <label class="mr-1 label-bold  w-75">Plan model </label>

                                                        <ng-select class="w-100"  [(ngModel)]="saveBo.cfssModel" [searchable]="true"
                                                        [clearable]="true" [items]="cfssModel" 
                                                       >
                                                      </ng-select>
                                                        
                                                    </div>
                                                    <!-- Description -->
                                                    <div class="col-lg-6 col-md-6 d-inline-flex ">
                                                        <label class="mr-1 label-bold  w-75"> Language </label>
                                                       
                                <ng-select class="w-100" [(ngModel)]="selectedLanguages" [searchable]="true"
                                [clearable]="true" [multiple]="true" [items]="languageList" bindLabel="languageName"
                                bindValue="id" name="languageIds" (ngModelChange)="languageselect()"
                                >

                              </ng-select>
                                                    </div>
                                                </div>
                                                <div class="row mt-1">
                                                    <!-- Start Date -->
                                                    <div class="col-lg-6 col-md-6 d-inline-flex ">
                                                        <label class="mr-1 label-bold w-75">Start Date<sup class="super-script">*</sup></label>
                                                        <input type="datetime-local" class="form-control w-100" (ngModelChange)="StartDateChange()"
                                                            #editstarttime [(ngModel)]="StartDate" [max]="startmin"
                                                            min="1000-01-01T00:00" />
                                                    </div>
                                                    <!-- End Date -->
                                                    <div class="col-lg-6 col-md-6 d-inline-flex ">
                                                        <label class="mr-1 label-bold w-75">End Date<sup class="super-script">*</sup></label>
                                                        <input type="datetime-local" class="form-control w-100"
                                                            [max]="startmin" [(ngModel)]="EndDate"
                                                            min="1000-01-01T00:00" />
                                                    </div>
                                                </div>
                                                <div class="row mt-1">
                                                    <!-- Title -->
                                                    <div class="col-lg-6 col-md-6 d-inline-flex ">
                                                        <label class="mr-1 label-bold  w-75">Event Title<sup class="super-script">*</sup></label>
                                                      

                                                            <textarea rows="7" class="form-control" cols="190"
                                                            [(ngModel)]="saveBo.eventTitle"></textarea>
                                                   
                                                    </div>
                                                    <!-- Description -->
                                                    <div class="col-lg-6 col-md-6 d-inline-flex ">
                                                        <label class="mr-1 label-bold  w-75"> Event Description </label>
                                                        <textarea rows="7" [(ngModel)]="saveBo.eventDescription"
                                                            class="form-control" cols="190"></textarea>

                                                    </div>
                                                </div>
                                                <div class="row mt-1">
                                                    <!--Client Name -->
                                                    <div class="col-lg-6 col-md-6 d-inline-flex ">
                                                        <label class="mr-1 label-bold w-75">Event Status<sup class="super-script">*</sup></label>
                                                        <ng-select [(ngModel)]="saveBo.statusLid" [searchable]="true"
                                                            class="w-100" [clearable]="true" [items]="StatusList"
                                                            bindLabel="lovName" bindValue="id">
                                                        </ng-select>
                                                    </div>

                                                    <!--Type of Contact -->
                                                <div class="col-lg-6 col-md-6 d-inline-flex ">
                                                    <label class="mr-1 label-bold w-75"> Type of Contact</label>
                                                    <ng-select [(ngModel)]="saveBo.typeofContactId"
                                                        [searchable]="true" class="w-100" [clearable]="true"
                                                        [items]="ContactList" bindLabel="lovName" bindValue="id">
                                                    </ng-select>
                                                </div>
                                                   
                                                </div> 
                                                <div class="row mt-3 ">
                                                 <!--Type of session -->
                                                 <div class="col-lg-6 col-md-6 d-inline-flex ">
                                                    <label class="mr-1 label-bold w-75"> Type of session</label>
                                                    <ng-select 
                                                        [searchable]="true" class="w-100" [clearable]="true"
                                                        [items]="ServiceList" [(ngModel)]="saveBo.typeofServiceId"
                                                       
                                                        bindLabel="serviceCode" bindValue="id">
                                                    </ng-select>
                                                </div>
                                            </div>
                                                <div class="row mt-3 ">
                                                    <div class="col-lg-12  col-md-12  col-sm-12 br-line">
                                                        <div class="row">
                                                            <div class="col-lg-6 col-md-6 d-inline-flex ">
                                                                <label class="mr-1 label-bold  w-75">Event
                                                                    Alerts</label>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-lg-3"></div>
                                                            <div class="col-lg-6">
                                                                <div class="row ">
                                                                    <ng-container
                                                                        *ngFor="let El of EventList;let i=index">
                                                                        <div class="col-lg-6">
                                                                            <input type="checkbox"
                                                                                [(ngModel)]="El.isCheck"> &nbsp;
                                                                            <label class="ml-2"
                                                                                style="font-weight: 800;">{{El.eventAlterName}}</label>
                                                                        </div>
                                                                    </ng-container>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div class="col-lg-2 divider d-none d-lg-block">
                                                    <div>
                                                      <div class="row  ms-1 mt-1 mb-1">
                                                        <div class="col-lg-12 col-md-12">
                                                          <div class="row" style="border-bottom:1px solid grey">
                                                            <h6 class="headerInfo-label ms-1">Missing Documents</h6>
                                                          </div> <!-- Case Manager: -->
                                                           <!-- <label class="font-header mt-3"
                                                            style="font-weight: bold;color: black;">Case Manager:</label> -->
                                                          <div class="row" *ngFor="let st of missingDocuments"  >
                                                            <div class="col-lg-12">
                                                              <label class="font-header" 
                                                                
                                                                >{{st}}</label>
                                                            </div>
                                                            <!-- <div class="col-lg-12">
                                                              <label class="font-header">{{ st.activeDate }}</label>
                                                            </div>
                                                            <div class="col-lg-12">
                                                              <label class="font-header">{{st.phone}}</label>
                                                            </div> -->
                                                          </div>
                                                          
                                                        
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>


                                            </div>
                                        </div>
                                        <br>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn  btn-sm" (click)="checkTime();" [disabled]="saveBo.clientId==null ||saveBo.clientId==undefined ||saveBo.clientId==''||
                StartDate==null || StartDate==undefined || StartDate=='' ||
                EndDate==null || EndDate==undefined || EndDate=='' || saveBo.statusLid==null || saveBo.statusLid=='' ||saveBo.statusLid==undefined
                || saveBo.consultantId ==null ||saveBo.consultantId ==undefined || saveBo.consultantId==''  
                || saveBo.eventTitle == null || saveBo.eventTitle == undefined || saveBo.eventTitle == ''
               ">
                    <span
                        *ngIf="saveBo.id==null|| saveBo.id==undefined|| saveBo.id=='00000000-0000-0000-0000-000000000000'">
                        Save & Close</span>
                    <span
                        *ngIf="saveBo.id!=null && saveBo.id!=undefined && saveBo.id!='00000000-0000-0000-0000-000000000000'">
                        Update & Close</span>
                </button>
                <button type="button" class="btn  btn-sm" data-bs-dismiss="modal"
                    (click)="clearEvents()">Cancel</button>
            </div>
        </div>
    </div>
</div>
<!-- delete Modal -->
<span id="openEventsDelete" data-bs-toggle="modal" data-bs-target="#modalEventsDelete"></span>
<div class="modal fade" id="modalEventsDelete" data-bs-backdrop="static">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                    <span>Delete </span>
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                Are you sure you want to Delete?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="DeleteEvents()">Yes</button>
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">No</button>
            </div>
        </div>
    </div>
</div>

<!-- call popup -->
<span id="opencallModel" data-bs-toggle="modal" data-bs-target="#modalCallPopup"></span>
<div class="modal fade" id="modalCallPopup" data-bs-backdrop="static">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                    <span>Reminder </span>
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                Do you want Reminder for this event?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="SaveCallEvent();" >Yes</button>
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal" (click)="saveBo.getConfirmation = false;SaveEvents();">No</button>
            </div>
        </div>
    </div>
</div>

<!-- no call -->
<span id="openNoCallModel" data-bs-toggle="modal" data-bs-target="#modalNoCallPopup"></span>
<div class="modal fade" id="modalNoCallPopup" data-bs-backdrop="static">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                    <span>No Reminder </span>
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                Reminder will not be sent for this event due to {{msg}}.
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal" (click)="saveBo.getConfirmation = false;SaveEvents();">Ok</button>
            </div>
        </div>
    </div>
</div>